import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box } from '@mui/material';

import PageWrapper from '../../common/PageWrapper';
import { useMerchant } from '../../contexts/MerchantContext';
import { useCanManagePortalUsers } from '../../hooks';
import { configurationPaths } from '../../util/constants';
import { PortalUsersTable } from './components/PortalUsersTable';

export const PortalUsers = () => {
  const { isLoading: merchantInfoLoading } = useMerchant();
  const canManagePortalUsers = useCanManagePortalUsers();

  if (!canManagePortalUsers) {
    return <Navigate to={configurationPaths.SETTINGS} replace />;
  }

  return (
    <PageWrapper
      data-testid="PORTAL_USERS"
      title="Manage users"
      description="Search, create, and manage portal users across merchants you manage."
      isLoading={merchantInfoLoading}
      sx={{ width: '100%' }}
    >
      <Box>
        <PortalUsersTable />
      </Box>
    </PageWrapper>
  );
};
